import React, { useCallback } from 'react'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'

import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import { WelcomeTradingAccountNavigation } from '../Navigation/WelcomeTradingAccountNavigation'
import TradingAccountPositionsTable from './TradingAccountPositionsTable'

import '../TradingAccount.scss'

interface Props {
  data: {
    id: string
    name: string
  }
}

const WelcomeTradingAccountPositionsPage: React.FC<Props> = ({ data }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const fetchData = useCallback(() => {
    return tradingAccountsApiClient.getWelcomeTradingAccountOpenPositions(data.id)
  }, [data.id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data: tradingAccountPositions = [], isLoading } = useFetchOne(fetchData)

  return (
    <React.Fragment>
      <WelcomeTradingAccountNavigation
        data={data}
        isEdit={false}
        tab={TradingAccountTab.Positions}
      />
      <Loading isLoading={isLoading}>
        <TradingAccountPositionsTable
          data={data}
          tradingAccountPositions={tradingAccountPositions}
        />
      </Loading>
    </React.Fragment>
  )
}

export default WelcomeTradingAccountPositionsPage
